// The activity type icons of iOS `ActivityType.systemImage` (Models/Activity.swift) in lucide, drawn in an IconBadge
// tinted like `ActivityRow` (a visit takes its result's color; see dashboardModel.activityTint).

import {
  ArrowLeftRight,
  Camera,
  CircleCheck,
  CirclePlus,
  FileText,
  Mail,
  MapPin,
  MessageSquare,
  NotebookText,
  Phone,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';
import type { ActivityType } from '@/contracts/enums';
import { IconBadge } from '@/ui';

export const ACTIVITY_ICONS: Readonly<Record<ActivityType, LucideIcon>> = {
  visit: MapPin,
  call: Phone,
  email: Mail,
  text: MessageSquare,
  note: NotebookText,
  meeting: Users,
  task: CircleCheck,
  stageChange: ArrowLeftRight,
  assignment: UserPlus,
  created: CirclePlus,
  photo: Camera,
  document: FileText,
};

export function ActivityGlyph({ type, color, size = 32 }: { type: ActivityType; color: string; size?: number }) {
  const Icon = ACTIVITY_ICONS[type] ?? NotebookText;
  return <IconBadge icon={<Icon />} color={color} size={size} />;
}
